import React from 'react';

const YellowBackArrowIcon = () => {
  return (
    <svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.67813 15.9997L43.3203 15.9997" stroke="#FFC801" strokeWidth="4" />
      <path d="M16.9023 23.6454L8.67927 15.9993L16.9023 8.35465" stroke="#FFC801" strokeWidth="4" />
    </svg>
  );
};

export default YellowBackArrowIcon;
